import { render, staticRenderFns } from "./AdminsTable.vue?vue&type=template&id=9824c3fe"
import script from "./AdminsTable.vue?vue&type=script&lang=js"
export * from "./AdminsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminsTable.vue?vue&type=style&index=0&id=9824c3fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports